var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "margin-top-3x" }, [
    _vm.loading
      ? _c("div", { staticClass: "text-center" }, [
          _c("i", { staticClass: "fa fa-spinner fa-spin fa-3x fa-fw" })
        ])
      : _c("div", { staticClass: "row margin-top-4x" }, [
          _c("div", { staticClass: "col-sm-12" }, [
            _c(
              "div",
              { staticClass: "margin-top-2x" },
              [
                _c("div", { staticClass: "table-responsive" }, [
                  _c("table", { staticClass: "table table-striped table-sm" }, [
                    _vm._m(0),
                    _vm._v(" "),
                    _vm.lounge_reservations && _vm.lounge_reservations.data
                      ? _c(
                          "tbody",
                          _vm._l(_vm.lounge_reservations.data, function(item) {
                            return _c("tr", [
                              _c("td", [
                                _vm._v(
                                  _vm._s(
                                    _vm._f("dateFormat")(
                                      item.created_at,
                                      "MM/DD/YYYY hh:mm A"
                                    )
                                  )
                                )
                              ]),
                              _vm._v(" "),
                              _c("td", [
                                _vm._v(_vm._s(item.reservation_number))
                              ]),
                              _vm._v(" "),
                              _c("td", [_vm._v(_vm._s(item.airport_code))]),
                              _vm._v(" "),
                              _c("td", [_vm._v(_vm._s(item.airport_name))]),
                              _vm._v(" "),
                              _c("td", [_vm._v(_vm._s(item.location_id))]),
                              _vm._v(" "),
                              _c("td", [_vm._v(_vm._s(item.lounge_code))]),
                              _vm._v(" "),
                              _c("td", [_vm._v(_vm._s(item.lounge_name))]),
                              _vm._v(" "),
                              _c("td", [_vm._v(_vm._s(item.terminal))]),
                              _vm._v(" "),
                              _c("td", [
                                item.lounge_location
                                  ? _c(
                                      "div",
                                      [
                                        _c("json-viewer", {
                                          attrs: { value: item.lounge_location }
                                        })
                                      ],
                                      1
                                    )
                                  : _vm._e()
                              ]),
                              _vm._v(" "),
                              _c("td", [_vm._v(_vm._s(item.flight_no))]),
                              _vm._v(" "),
                              _c("td", [_vm._v(_vm._s(item.lpbc_url))]),
                              _vm._v(" "),
                              _c("td", [_vm._v(_vm._s(item.pass_ref))]),
                              _vm._v(" "),
                              _c("td", [
                                _vm._v(
                                  _vm._s(
                                    _vm._f("dateFormat")(
                                      item.date_of_visit,
                                      "MM/DD/YYYY"
                                    )
                                  )
                                )
                              ]),
                              _vm._v(" "),
                              _c("td", [_vm._v(_vm._s(item.time_of_visit))]),
                              _vm._v(" "),
                              _c("td", [_vm._v(_vm._s(item.customer_email))]),
                              _vm._v(" "),
                              _c("td", [
                                _vm._v(_vm._s(item.customer_telephone))
                              ]),
                              _vm._v(" "),
                              _c("td", [_vm._v(_vm._s(item.customer_fax))]),
                              _vm._v(" "),
                              _c("td", [
                                item.customer_address
                                  ? _c(
                                      "div",
                                      [
                                        _c("json-viewer", {
                                          attrs: {
                                            value: item.customer_address
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  : _vm._e()
                              ]),
                              _vm._v(" "),
                              _c("td", [_vm._v(_vm._s(item.destination))]),
                              _vm._v(" "),
                              _c("td", [_vm._v(_vm._s(item.data_protection))]),
                              _vm._v(" "),
                              _c("td", [_vm._v(_vm._s(item.contact_name))]),
                              _vm._v(" "),
                              _c("td", [
                                _vm._v(_vm._s(item.lead_passenger_name))
                              ]),
                              _vm._v(" "),
                              _c("td", [
                                item.passengers
                                  ? _c(
                                      "div",
                                      [
                                        _c("json-viewer", {
                                          attrs: { value: item.passengers }
                                        })
                                      ],
                                      1
                                    )
                                  : _vm._e()
                              ]),
                              _vm._v(" "),
                              _c("td", [_vm._v(_vm._s(item.base_price))]),
                              _vm._v(" "),
                              _c("td", [_vm._v(_vm._s(item.markup_amount))]),
                              _vm._v(" "),
                              _c("td", [_vm._v(_vm._s(item.total_price))]),
                              _vm._v(" "),
                              _c("td", [
                                _vm._v(_vm._s(item.channel_commission))
                              ]),
                              _vm._v(" "),
                              _c("td", [
                                _vm._v(_vm._s(item.reslab_commission))
                              ]),
                              _vm._v(" "),
                              _c("td", [
                                _vm._v(_vm._s(item.channel_markup_type))
                              ]),
                              _vm._v(" "),
                              _c("td", [
                                _vm._v(_vm._s(item.channel_markup_value))
                              ]),
                              _vm._v(" "),
                              _c("td", [_vm._v(_vm._s(item.reslab_fee_type))]),
                              _vm._v(" "),
                              _c("td", [_vm._v(_vm._s(item.reslab_fee_value))]),
                              _vm._v(" "),
                              _c("td", [_vm._v(_vm._s(item.currency))]),
                              _vm._v(" "),
                              _c("td", [_vm._v(_vm._s(item.status))])
                            ])
                          }),
                          0
                        )
                      : _vm._e()
                  ])
                ]),
                _vm._v(" "),
                _vm.lounge_reservations && _vm.lounge_reservations.last_page
                  ? _c("pagination", {
                      attrs: {
                        "pages-number": _vm.lounge_reservations.last_page
                      },
                      on: {
                        pageChanged: function(page) {
                          return _vm.loadLoungeReservations(page)
                        }
                      }
                    })
                  : _vm._e()
              ],
              1
            )
          ])
        ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("Created at")]),
        _vm._v(" "),
        _c("th", [_vm._v("Res #")]),
        _vm._v(" "),
        _c("th", [_vm._v("Airport Code")]),
        _vm._v(" "),
        _c("th", [_vm._v("Airport Name")]),
        _vm._v(" "),
        _c("th", [_vm._v("Location ID")]),
        _vm._v(" "),
        _c("th", [_vm._v("Lounge Code")]),
        _vm._v(" "),
        _c("th", [_vm._v("Lounge Name")]),
        _vm._v(" "),
        _c("th", [_vm._v("Terminal")]),
        _vm._v(" "),
        _c("th", [_vm._v("Lounge Location")]),
        _vm._v(" "),
        _c("th", [_vm._v("flight number")]),
        _vm._v(" "),
        _c("th", [_vm._v("Lpbc Url")]),
        _vm._v(" "),
        _c("th", [_vm._v("Pass Ref")]),
        _vm._v(" "),
        _c("th", [_vm._v("Date of visit")]),
        _vm._v(" "),
        _c("th", [_vm._v("Time of visit")]),
        _vm._v(" "),
        _c("th", [_vm._v("Customer Email")]),
        _vm._v(" "),
        _c("th", [_vm._v("Customer Telephone")]),
        _vm._v(" "),
        _c("th", [_vm._v("Customer Fax")]),
        _vm._v(" "),
        _c("th", [_vm._v("Customer Address")]),
        _vm._v(" "),
        _c("th", [_vm._v("Destination")]),
        _vm._v(" "),
        _c("th", [_vm._v("Data Protection")]),
        _vm._v(" "),
        _c("th", [_vm._v("contact Name")]),
        _vm._v(" "),
        _c("th", [_vm._v("Lead Passenger Name")]),
        _vm._v(" "),
        _c("th", [_vm._v("Passengers")]),
        _vm._v(" "),
        _c("th", [_vm._v("Base Price")]),
        _vm._v(" "),
        _c("th", [_vm._v("Markup amount")]),
        _vm._v(" "),
        _c("th", [_vm._v("Total Price")]),
        _vm._v(" "),
        _c("th", [_vm._v("Channel Commission")]),
        _vm._v(" "),
        _c("th", [_vm._v("Reslab Commission")]),
        _vm._v(" "),
        _c("th", [_vm._v("Channel markup type")]),
        _vm._v(" "),
        _c("th", [_vm._v("Channel markup value")]),
        _vm._v(" "),
        _c("th", [_vm._v("Reslab fee type")]),
        _vm._v(" "),
        _c("th", [_vm._v("Reslab fee value")]),
        _vm._v(" "),
        _c("th", [_vm._v("Currency")]),
        _vm._v(" "),
        _c("th", [_vm._v("Status")])
      ])
    ])
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2c493e68", { render: render, staticRenderFns: staticRenderFns })
  }
}